<template>
  <div class="modal-children-count">
    <!-- ラベル -->
    <button
      class="modal-children-count__button --pseudo-input"
      :class="{
        'is-focused': isModalActive,
      }"
      @click="switchModal(true)"
    >
      <span class="modal-children-count__label --button">子ども</span>
      <span class="modal-children-count__label --button">{{ currentTotalLength }}人</span>
      <img
        src="@/assets/icon/icon_select_arrow_black.svg"
        alt=""
        class="modal-children-count__icon"
        :class="{ 'is-focused': isModalActive }"
      >
    </button>

    <!-- モーダル -->
    <div
      v-if="isModalActive"
      class="modal-children-count__wrap --modal"
    >
      <div
        class="modal-children-count__modal"
      :class="{ 'is-right': isRight }"
      >
        <!-- heading -->
        <div class="modal-children-count__heading">
          <span>子どもの人数を選択してください</span>
          <button
            class="modal-children-count__button --close-icon"
            @click="emitList()"
          ></button>
        </div>
        <!-- body -->
        <div class="modal-children-count__body">
          <!-- 小学生 -->
          <div class="modal-children-count__wrap --student">
            <div class="modal-children-count__label">小学生</div>
            <div class="modal-children-count__wrap --select">
              <CounterChildren
                :list="studentList"
                :currentTotalLength="currentTotalLength"
                @changed="e => updateList(e, 'student')"
              />
            </div>
          </div>
          <!-- 幼児 -->
          <div class="modal-children-count__wrap --infant">
            <div class="modal-children-count__label">幼児</div>
            <div class="modal-children-count__wrap --select">
              <CounterChildren
                :list="infantList"
                :currentTotalLength="currentTotalLength"
                @changed="e => updateList(e, 'infant')"
              />
            </div>
          </div>
        </div>
        <!-- footer -->
        <div class="modal-children-count__footer">
          <AppButton
            label="リセット"
            theme="pale-white"
            :maxWidth="160"
            class="select-category__button --reset"
            @clicked="resetList()"
          />
          <AppButton
            label="決定"
            theme="black"
            :maxWidth="160"
            class="select-category__button --dicision"
            @clicked="emitList()"
          />
        </div>
      </div>
    </div>

    <!-- 背景 -->
    <div
      v-if="isModalActive"
      class="modal-children-count__background"
      @click="emitList()"
    ></div>
  </div>
</template>

<script>
// TOP以外でこのコンポーネントを使用した際に、
// 現状設定されている値をqueryから引っ張ってくる処理を追加したい

import AppButton from '@/components/elements/AppButton/'
import CounterChildren from './CounterChildren.vue'

export default {
  components: {
    AppButton,
    CounterChildren
  },
  props: {
    isRight: {
      type: Boolean,
      required: false,
      default: false
    }, // 表示基準
    exUpperGradesHeadCnt: {
      type: [Number, String],
      required: false,
      default: 0
    }, // 高学年
    exLowerGradesHeadCnt: {
      type: [Number, String],
      required: false,
      default: 0
    }, // 低学年
    youjiAHeadCnt: {
      type: [Number, String],
      required: false,
      default: 0
    }, // 食事・布団付き
    youjiBHeadCnt: {
      type: [Number, String],
      required: false,
      default: 0
    }, // 食事のみ
    youjiCHeadCnt: {
      type: [Number, String],
      required: false,
      default: 0
    }, // 布団のみ
    youjiDHeadCnt: {
      type: [Number, String],
      required: false,
      default: 0
    }, // 食事・布団不要
  },
  data() {
    return {
      isModalActive: false,  // モーダルの表示状態
      currentTotalLength: 0, // 現在設定されているトータルの人数
      studentList: [
        { id: 'exUpperGradesHeadCnt', label: '高学年', value: this.exUpperGradesHeadCnt },
        { id: 'exLowerGradesHeadCnt', label: '低学年', value: this.exLowerGradesHeadCnt },
      ], // 小学生
      infantList: [
        { id: 'youjiAHeadCnt', label: '食事・布団付き', value: this.youjiAHeadCnt },
        { id: 'youjiBHeadCnt', label: '食事のみ', value: this.youjiBHeadCnt },
        { id: 'youjiCHeadCnt', label: '布団のみ', value: this.youjiCHeadCnt },
        { id: 'youjiDHeadCnt', label: '食事・布団不要', value: this.youjiDHeadCnt },
      ], // 幼児
    }
  },
  mounted() {
    this.setCurrentTotalLength()
  },
  methods: {
    /**
     * 
     */
    switchModal(bool) {
      this.isModalActive = bool
    },
    /**
     * コンポーネントから更新されたリスト情報を反映
     * @param {array} newList 
     * @param {string} type 
     */
    updateList(newList, type) {
      if (type === 'student') { this.studentList = newList }
      if (type === 'infant') { this.infantList = newList }
      this.setCurrentTotalLength()
    },
    /**
     * 更新された配列から、現在設定されている合計人数を算出
     */
    setCurrentTotalLength() {
      const studentLength = this.studentList.map(d => d.value).reduce((a, b) => a + b)
      const infantLength = this.infantList.map(d => d.value).reduce((a, b) => a + b)
      this.currentTotalLength = studentLength + infantLength
    },
    /**
     * リセットボタンが押下されたら、各リストの人数（value）を全て0にする
     */
    resetList() {
      this.studentList = this.studentList.map(d => {
        return { ...d, value: 0 }
      })
      this.infantList = this.infantList.map(d => {
        return { ...d, value: 0 }
      })
      this.setCurrentTotalLength()
    },
    /**
     * 小学生・幼児を結合した配列をemitする
     */
    emitList() {
      const childrenList = [...this.studentList, ...this.infantList]
      this.$emit('inputed', childrenList)
      this.isModalActive = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixins.scss';
@import '@/assets/scss/variables.scss';

.modal-children-count {
  position: relative;
  

  &__button {
    &.--pseudo-input {
      background-color: $white;
      border-radius: 0.25rem;
      color: $cool-gray-4;
      cursor: pointer;
      font-size: .875rem;
      height: calc(2.5rem - 2px);
      overflow: hidden;
      position: relative;
      padding: 0 .5rem;
      text-align: left;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;

      @include hover {
        outline: 2px solid black;
        outline-offset: -1px;
      }

      &:focus-within,
      &.is-focused {
        outline: 2px solid black;
        outline-offset: -1px;
      }

      @include sp {
        height: 2.5rem;
      }
    }

    &.--close-icon {
      background-color: transparent;
      cursor: pointer;
      height: 3rem;
      position: absolute;
      right: 0;
      top: 0;
      width: 3rem;

      &::before,
      &::after {
        background-color: $black;
        content: '';
        display: block;
        height: 1px;
        pointer-events: none;
        position: absolute;
        right: 0.75rem;
        top: 50%;
        width: 1.5rem;
      }

      &::before {
        transform: rotateZ(45deg);
      }

      &::after {
        transform: rotateZ(135deg);
      }
    }

    &.--minus,
    &.--plus {
      background-color: transparent;
      cursor: pointer;
      display: block;
      height: 1.5rem;
      width: 1.5rem;
    }

    &.--minus {
      margin-right: .25rem;
    }

    &.--reset {
      border: 1px solid $cool-gray-4;
      border-radius: 0.25rem;
      height: 3rem;
      line-height: 3rem;
      max-width: 10rem;
      text-align: center;
    }

    &.--dicision {
      background-color: $black;
      border-radius: 0.25rem;
      color: $white;
      font-weight: bold;
      height: 3rem;
      line-height: 3rem;
      max-width: 10rem;
      text-align: center;
    }
  }

  &__icon {
    display: block;
    height: auto;
    position: absolute;
    right: .5rem;
    top: calc(50% - .375rem);
    transition: transform .2s;
    width: .75rem;
    z-index: 1;

    &.is-focused {
      transform: rotateZ(180deg);
    }
  }

  &__modal {
      background-color: $white;
      border-radius: 0.25rem;
      box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.16);
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      left: 0;
      overflow: hidden;
      padding-bottom: 5rem;
      pointer-events: auto;
      position: absolute;
      top: auto;
      width: 30rem;
      z-index: 10001;

      &.is-right {
        left: auto;
        right: 0;
      }

      @include tablet {
        left: auto;
        max-width: 30rem;
        pointer-events: auto;
        width: calc(100% - 2rem);

        &.is-right {
          right: auto;
        }
      }
  }

  &__wrap {

    &.--modal {
      @include tablet {
        align-items: center;
        display: flex;
        height: 100%;
        justify-content: center;
        left: 0;
        pointer-events: none;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 10001;
      }
    }

    &.--student {
      align-items: center;
      border-bottom: 1px solid $cool-gray-4;
      display: flex;
      justify-content: center;
      margin-bottom: 1.5rem;
      padding-bottom: 1.5rem;

      @include sp {
        flex-wrap: wrap;
        margin-bottom: 1rem;
        padding-bottom: 1rem;
      }
    }

    &.--infant {
      align-items: center;
      display: flex;
      justify-content: center;

      @include sp {
        flex-wrap: wrap;
      }
    }

    &.--select {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      width: calc(100% - 5rem);

      @include sp {
        max-width: 20rem;
        width: 100%;
      }
    }

    &.--select-inner {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      width: 50%;
    }
  }

  &__background {
    background-color: rgba($black, .5);
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
  }

  &__heading {
    background-color: $cool-gray-4;
    font-size: 1rem;
    font-weight: bold;
    height: 3rem;
    left: 0;
    line-height: 1rem;
    max-width: 30rem;
    padding: 1rem;
    top: 0;
    width: 100%;
  }

  &__body {
    padding: 2rem 1rem;

    @include sp {
      padding: 1rem;
    }
  }

  &__label {
    font-size: 1rem;
    font-weight: bold;
    width: 5rem;

    @include sp {
      margin-bottom: .5rem;
      max-width: 20rem;
      width: 100%;
    }

    &.--button {
      color: $black;
      font-family: inherit;
      font-size: .875rem;
      font-weight: normal;
      margin-right: .375rem;
    }
  }

  &__select {
    background-color: transparent;
    border: 1px solid $cool-gray-3;
    height: 2.5rem;
    margin-right: .25rem;
    max-width: 5rem;

    @include sp {
    }
  }

  &__footer {
    align-items: center;
    background-color: $white;
    bottom: 0;
    display: flex;
    filter: drop-shadow(0 2px 3px rgba($black, .5));
    gap: 1rem;
    height: 5rem;
    justify-content: center;
    padding: 0 1rem;
    position: absolute;
    width: 100%;
  }
}
</style>